@theme {
  --color-ember-50: var(--ember-50);
  --color-ember-100: var(--ember-100);
  --color-ember-150: var(--ember-150);
  --color-ember-200: var(--ember-200);
  --color-ember-250: var(--ember-250);
  --color-ember-300: var(--ember-300);
  --color-ember-350: var(--ember-350);
  --color-ember-400: var(--ember-400);
  --color-ember-450: var(--ember-450);
  --color-ember-500: var(--ember-500);
  --color-ember-550: var(--ember-550);
  --color-ember-600: var(--ember-600);
  --color-ember-650: var(--ember-650);
  --color-ember-700: var(--ember-700);
  --color-ember-750: var(--ember-750);
  --color-ember-800: var(--ember-800);
  --color-ember-850: var(--ember-850);
  --color-ember-900: var(--ember-900);
  --color-ember-950: var(--ember-950);
  --color-ember-1000: var(--ember-1000);
  --color-ember-1050: var(--ember-1050);
  --color-earthfire-50: var(--earthfire-50);
  --color-earthfire-100: var(--earthfire-100);
  --color-earthfire-150: var(--earthfire-150);
  --color-earthfire-200: var(--earthfire-200);
  --color-earthfire-250: var(--earthfire-250);
  --color-earthfire-300: var(--earthfire-300);
  --color-earthfire-350: var(--earthfire-350);
  --color-earthfire-400: var(--earthfire-400);
  --color-earthfire-450: var(--earthfire-450);
  --color-earthfire-500: var(--earthfire-500);
  --color-earthfire-550: var(--earthfire-550);
  --color-earthfire-600: var(--earthfire-600);
  --color-earthfire-650: var(--earthfire-650);
  --color-earthfire-700: var(--earthfire-700);
  --color-earthfire-750: var(--earthfire-750);
  --color-earthfire-800: var(--earthfire-800);
  --color-earthfire-850: var(--earthfire-850);
  --color-earthfire-900: var(--earthfire-900);
  --color-earthfire-950: var(--earthfire-950);
  --color-earthfire-1000: var(--earthfire-1000);
  --color-earthfire-1050: var(--earthfire-1050);
  --color-fuchsia-heat-50: var(--fuchsia-heat-50);
  --color-fuchsia-heat-100: var(--fuchsia-heat-100);
  --color-fuchsia-heat-150: var(--fuchsia-heat-150);
  --color-fuchsia-heat-200: var(--fuchsia-heat-200);
  --color-fuchsia-heat-250: var(--fuchsia-heat-250);
  --color-fuchsia-heat-300: var(--fuchsia-heat-300);
  --color-fuchsia-heat-350: var(--fuchsia-heat-350);
  --color-fuchsia-heat-400: var(--fuchsia-heat-400);
  --color-fuchsia-heat-450: var(--fuchsia-heat-450);
  --color-fuchsia-heat-500: var(--fuchsia-heat-500);
  --color-fuchsia-heat-550: var(--fuchsia-heat-550);
  --color-fuchsia-heat-600: var(--fuchsia-heat-600);
  --color-fuchsia-heat-650: var(--fuchsia-heat-650);
  --color-fuchsia-heat-700: var(--fuchsia-heat-700);
  --color-fuchsia-heat-750: var(--fuchsia-heat-750);
  --color-fuchsia-heat-800: var(--fuchsia-heat-800);
  --color-fuchsia-heat-850: var(--fuchsia-heat-850);
  --color-fuchsia-heat-900: var(--fuchsia-heat-900);
  --color-fuchsia-heat-950: var(--fuchsia-heat-950);
  --color-fuchsia-heat-1000: var(--fuchsia-heat-1000);
  --color-fuchsia-heat-1050: var(--fuchsia-heat-1050);
  --color-polar-glow-50: var(--polar-glow-50);
  --color-polar-glow-100: var(--polar-glow-100);
  --color-polar-glow-150: var(--polar-glow-150);
  --color-polar-glow-200: var(--polar-glow-200);
  --color-polar-glow-250: var(--polar-glow-250);
  --color-polar-glow-300: var(--polar-glow-300);
  --color-polar-glow-350: var(--polar-glow-350);
  --color-polar-glow-400: var(--polar-glow-400);
  --color-polar-glow-450: var(--polar-glow-450);
  --color-polar-glow-500: var(--polar-glow-500);
  --color-polar-glow-550: var(--polar-glow-550);
  --color-polar-glow-600: var(--polar-glow-600);
  --color-polar-glow-650: var(--polar-glow-650);
  --color-polar-glow-700: var(--polar-glow-700);
  --color-polar-glow-750: var(--polar-glow-750);
  --color-polar-glow-800: var(--polar-glow-800);
  --color-polar-glow-850: var(--polar-glow-850);
  --color-polar-glow-900: var(--polar-glow-900);
  --color-polar-glow-950: var(--polar-glow-950);
  --color-polar-glow-1000: var(--polar-glow-1000);
  --color-polar-glow-1050: var(--polar-glow-1050);
  --color-glacier-pool-50: var(--glacier-pool-50);
  --color-glacier-pool-100: var(--glacier-pool-100);
  --color-glacier-pool-150: var(--glacier-pool-150);
  --color-glacier-pool-200: var(--glacier-pool-200);
  --color-glacier-pool-250: var(--glacier-pool-250);
  --color-glacier-pool-300: var(--glacier-pool-300);
  --color-glacier-pool-350: var(--glacier-pool-350);
  --color-glacier-pool-400: var(--glacier-pool-400);
  --color-glacier-pool-450: var(--glacier-pool-450);
  --color-glacier-pool-500: var(--glacier-pool-500);
  --color-glacier-pool-550: var(--glacier-pool-550);
  --color-glacier-pool-600: var(--glacier-pool-600);
  --color-glacier-pool-650: var(--glacier-pool-650);
  --color-glacier-pool-700: var(--glacier-pool-700);
  --color-glacier-pool-750: var(--glacier-pool-750);
  --color-glacier-pool-800: var(--glacier-pool-800);
  --color-glacier-pool-850: var(--glacier-pool-850);
  --color-glacier-pool-900: var(--glacier-pool-900);
  --color-glacier-pool-950: var(--glacier-pool-950);
  --color-glacier-pool-1000: var(--glacier-pool-1000);
  --color-glacier-pool-1050: var(--glacier-pool-1050);
  --color-deep-current-50: var(--deep-current-50);
  --color-deep-current-100: var(--deep-current-100);
  --color-deep-current-150: var(--deep-current-150);
  --color-deep-current-200: var(--deep-current-200);
  --color-deep-current-250: var(--deep-current-250);
  --color-deep-current-300: var(--deep-current-300);
  --color-deep-current-350: var(--deep-current-350);
  --color-deep-current-400: var(--deep-current-400);
  --color-deep-current-450: var(--deep-current-450);
  --color-deep-current-500: var(--deep-current-500);
  --color-deep-current-550: var(--deep-current-550);
  --color-deep-current-600: var(--deep-current-600);
  --color-deep-current-650: var(--deep-current-650);
  --color-deep-current-700: var(--deep-current-700);
  --color-deep-current-750: var(--deep-current-750);
  --color-deep-current-800: var(--deep-current-800);
  --color-deep-current-850: var(--deep-current-850);
  --color-deep-current-900: var(--deep-current-900);
  --color-deep-current-950: var(--deep-current-950);
  --color-deep-current-1000: var(--deep-current-1000);
  --color-deep-current-1050: var(--deep-current-1050);
  --color-blue-red-50: var(--blue-red-50);
  --color-blue-red-100: var(--blue-red-100);
  --color-blue-red-150: var(--blue-red-150);
  --color-blue-red-200: var(--blue-red-200);
  --color-blue-red-250: var(--blue-red-250);
  --color-blue-red-300: var(--blue-red-300);
  --color-blue-red-350: var(--blue-red-350);
  --color-blue-red-400: var(--blue-red-400);
  --color-blue-red-450: var(--blue-red-450);
  --color-blue-red-500: var(--blue-red-500);
  --color-blue-red-550: var(--blue-red-550);
  --color-blue-red-600: var(--blue-red-600);
  --color-blue-red-650: var(--blue-red-650);
  --color-blue-red-700: var(--blue-red-700);
  --color-blue-red-750: var(--blue-red-750);
  --color-blue-red-800: var(--blue-red-800);
  --color-blue-red-850: var(--blue-red-850);
  --color-blue-red-900: var(--blue-red-900);
  --color-blue-red-950: var(--blue-red-950);
  --color-blue-red-1000: var(--blue-red-1000);
  --color-blue-orange-50: var(--blue-orange-50);
  --color-blue-orange-100: var(--blue-orange-100);
  --color-blue-orange-150: var(--blue-orange-150);
  --color-blue-orange-200: var(--blue-orange-200);
  --color-blue-orange-250: var(--blue-orange-250);
  --color-blue-orange-300: var(--blue-orange-300);
  --color-blue-orange-350: var(--blue-orange-350);
  --color-blue-orange-400: var(--blue-orange-400);
  --color-blue-orange-450: var(--blue-orange-450);
  --color-blue-orange-500: var(--blue-orange-500);
  --color-blue-orange-550: var(--blue-orange-550);
  --color-blue-orange-600: var(--blue-orange-600);
  --color-blue-orange-650: var(--blue-orange-650);
  --color-blue-orange-700: var(--blue-orange-700);
  --color-blue-orange-750: var(--blue-orange-750);
  --color-blue-orange-800: var(--blue-orange-800);
  --color-blue-orange-850: var(--blue-orange-850);
  --color-blue-orange-900: var(--blue-orange-900);
  --color-blue-orange-950: var(--blue-orange-950);
  --color-blue-orange-1000: var(--blue-orange-1000);
  --color-purple-yellow-50: var(--purple-yellow-50);
  --color-purple-yellow-100: var(--purple-yellow-100);
  --color-purple-yellow-150: var(--purple-yellow-150);
  --color-purple-yellow-200: var(--purple-yellow-200);
  --color-purple-yellow-250: var(--purple-yellow-250);
  --color-purple-yellow-300: var(--purple-yellow-300);
  --color-purple-yellow-350: var(--purple-yellow-350);
  --color-purple-yellow-400: var(--purple-yellow-400);
  --color-purple-yellow-450: var(--purple-yellow-450);
  --color-purple-yellow-500: var(--purple-yellow-500);
  --color-purple-yellow-550: var(--purple-yellow-550);
  --color-purple-yellow-600: var(--purple-yellow-600);
  --color-purple-yellow-650: var(--purple-yellow-650);
  --color-purple-yellow-700: var(--purple-yellow-700);
  --color-purple-yellow-750: var(--purple-yellow-750);
  --color-purple-yellow-800: var(--purple-yellow-800);
  --color-purple-yellow-850: var(--purple-yellow-850);
  --color-purple-yellow-900: var(--purple-yellow-900);
  --color-purple-yellow-950: var(--purple-yellow-950);
  --color-purple-yellow-1000: var(--purple-yellow-1000);
  --color-fuchsia-teal-50: var(--fuchsia-teal-50);
  --color-fuchsia-teal-100: var(--fuchsia-teal-100);
  --color-fuchsia-teal-150: var(--fuchsia-teal-150);
  --color-fuchsia-teal-200: var(--fuchsia-teal-200);
  --color-fuchsia-teal-250: var(--fuchsia-teal-250);
  --color-fuchsia-teal-300: var(--fuchsia-teal-300);
  --color-fuchsia-teal-350: var(--fuchsia-teal-350);
  --color-fuchsia-teal-400: var(--fuchsia-teal-400);
  --color-fuchsia-teal-450: var(--fuchsia-teal-450);
  --color-fuchsia-teal-500: var(--fuchsia-teal-500);
  --color-fuchsia-teal-550: var(--fuchsia-teal-550);
  --color-fuchsia-teal-600: var(--fuchsia-teal-600);
  --color-fuchsia-teal-650: var(--fuchsia-teal-650);
  --color-fuchsia-teal-700: var(--fuchsia-teal-700);
  --color-fuchsia-teal-750: var(--fuchsia-teal-750);
  --color-fuchsia-teal-800: var(--fuchsia-teal-800);
  --color-fuchsia-teal-850: var(--fuchsia-teal-850);
  --color-fuchsia-teal-900: var(--fuchsia-teal-900);
  --color-fuchsia-teal-950: var(--fuchsia-teal-950);
  --color-fuchsia-teal-1000: var(--fuchsia-teal-1000);
}

:root {
  --ember-50: rgb(34, 39, 43);
  --ember-100: rgb(28, 42, 59);
  --ember-150: rgb(28, 42, 76);
  --ember-200: rgb(37, 38, 92);
  --ember-250: rgb(51, 31, 104);
  --ember-300: rgb(68, 17, 112);
  --ember-350: rgb(97, 17, 117);
  --ember-400: rgb(128, 15, 115);
  --ember-450: rgb(159, 9, 106);
  --ember-500: rgb(188, 7, 88);
  --ember-550: rgb(215, 21, 58);
  --ember-600: rgb(222, 43, 52);
  --ember-650: rgb(228, 59, 46);
  --ember-700: rgb(233, 73, 39);
  --ember-750: rgb(238, 86, 33);
  --ember-800: rgb(243, 99, 27);
  --ember-850: rgb(247, 115, 0);
  --ember-900: rgb(249, 130, 0);
  --ember-950: rgb(251, 145, 0);
  --ember-1000: rgb(251, 160, 0);
  --ember-1050: rgb(250, 175, 5);
  --earthfire-50: rgb(82, 55, 25);
  --earthfire-100: rgb(95, 54, 13);
  --earthfire-150: rgb(108, 51, 0);
  --earthfire-200: rgb(122, 46, 0);
  --earthfire-250: rgb(135, 38, 0);
  --earthfire-300: rgb(148, 27, 0);
  --earthfire-350: rgb(167, 42, 5);
  --earthfire-400: rgb(185, 56, 11);
  --earthfire-450: rgb(204, 70, 17);
  --earthfire-500: rgb(224, 85, 22);
  --earthfire-550: rgb(243, 99, 27);
  --earthfire-600: rgb(247, 115, 0);
  --earthfire-650: rgb(249, 130, 0);
  --earthfire-700: rgb(251, 145, 0);
  --earthfire-750: rgb(251, 160, 0);
  --earthfire-800: rgb(250, 175, 5);
  --earthfire-850: rgb(250, 187, 59);
  --earthfire-900: rgb(250, 199, 87);
  --earthfire-950: rgb(251, 210, 111);
  --earthfire-1000: rgb(252, 221, 133);
  --earthfire-1050: rgb(253, 231, 154);
  --fuchsia-heat-50: rgb(101, 0, 77);
  --fuchsia-heat-100: rgb(123, 2, 95);
  --fuchsia-heat-150: rgb(146, 4, 114);
  --fuchsia-heat-200: rgb(169, 8, 133);
  --fuchsia-heat-250: rgb(193, 13, 153);
  --fuchsia-heat-300: rgb(217, 18, 174);
  --fuchsia-heat-350: rgb(230, 30, 146);
  --fuchsia-heat-400: rgb(240, 45, 119);
  --fuchsia-heat-450: rgb(245, 62, 91);
  --fuchsia-heat-500: rgb(246, 80, 62);
  --fuchsia-heat-550: rgb(243, 99, 27);
  --fuchsia-heat-600: rgb(247, 115, 0);
  --fuchsia-heat-650: rgb(249, 130, 0);
  --fuchsia-heat-700: rgb(251, 145, 0);
  --fuchsia-heat-750: rgb(251, 160, 0);
  --fuchsia-heat-800: rgb(250, 175, 5);
  --fuchsia-heat-850: rgb(250, 187, 59);
  --fuchsia-heat-900: rgb(250, 199, 87);
  --fuchsia-heat-950: rgb(251, 210, 111);
  --fuchsia-heat-1000: rgb(252, 221, 133);
  --fuchsia-heat-1050: rgb(253, 231, 154);
  --polar-glow-50: rgb(0, 38, 100);
  --polar-glow-100: rgb(1, 51, 128);
  --polar-glow-150: rgb(3, 65, 158);
  --polar-glow-200: rgb(7, 79, 189);
  --polar-glow-250: rgb(13, 93, 220);
  --polar-glow-300: rgb(20, 108, 253);
  --polar-glow-350: rgb(0, 119, 231);
  --polar-glow-400: rgb(0, 126, 208);
  --polar-glow-450: rgb(0, 130, 184);
  --polar-glow-500: rgb(0, 130, 162);
  --polar-glow-550: rgb(46, 128, 142);
  --polar-glow-600: rgb(66, 146, 159);
  --polar-glow-650: rgb(84, 163, 176);
  --polar-glow-700: rgb(103, 182, 193);
  --polar-glow-750: rgb(121, 200, 211);
  --polar-glow-800: rgb(140, 219, 229);
  --polar-glow-850: rgb(154, 223, 229);
  --polar-glow-900: rgb(169, 227, 229);
  --polar-glow-950: rgb(182, 231, 230);
  --polar-glow-1000: rgb(196, 235, 231);
  --polar-glow-1050: rgb(209, 238, 234);
  --glacier-pool-50: rgb(68, 17, 112);
  --glacier-pool-100: rgb(81, 30, 136);
  --glacier-pool-150: rgb(93, 43, 161);
  --glacier-pool-200: rgb(106, 57, 187);
  --glacier-pool-250: rgb(117, 70, 214);
  --glacier-pool-300: rgb(128, 85, 241);
  --glacier-pool-350: rgb(115, 89, 246);
  --glacier-pool-400: rgb(100, 94, 250);
  --glacier-pool-450: rgb(83, 98, 252);
  --glacier-pool-500: rgb(60, 103, 253);
  --glacier-pool-550: rgb(20, 108, 253);
  --glacier-pool-600: rgb(0, 137, 255);
  --glacier-pool-650: rgb(12, 162, 255);
  --glacier-pool-700: rgb(59, 185, 255);
  --glacier-pool-750: rgb(100, 205, 255);
  --glacier-pool-800: rgb(140, 224, 255);
  --glacier-pool-850: rgb(154, 227, 255);
  --glacier-pool-900: rgb(167, 229, 255);
  --glacier-pool-950: rgb(179, 232, 254);
  --glacier-pool-1000: rgb(191, 234, 254);
  --glacier-pool-1050: rgb(203, 237, 253);
  --deep-current-50: rgb(11, 63, 71);
  --deep-current-100: rgb(18, 75, 84);
  --deep-current-150: rgb(25, 88, 98);
  --deep-current-200: rgb(32, 101, 113);
  --deep-current-250: rgb(39, 114, 127);
  --deep-current-300: rgb(46, 128, 142);
  --deep-current-350: rgb(0, 130, 162);
  --deep-current-400: rgb(0, 130, 184);
  --deep-current-450: rgb(0, 126, 208);
  --deep-current-500: rgb(0, 119, 231);
  --deep-current-550: rgb(20, 108, 253);
  --deep-current-600: rgb(0, 137, 255);
  --deep-current-650: rgb(12, 162, 255);
  --deep-current-700: rgb(59, 185, 255);
  --deep-current-750: rgb(100, 205, 255);
  --deep-current-800: rgb(140, 224, 255);
  --deep-current-850: rgb(154, 227, 255);
  --deep-current-900: rgb(167, 229, 255);
  --deep-current-950: rgb(179, 232, 254);
  --deep-current-1000: rgb(191, 234, 254);
  --deep-current-1050: rgb(203, 237, 253);
  --blue-red-50: rgb(0, 38, 100);
  --blue-red-100: rgb(1, 51, 128);
  --blue-red-150: rgb(3, 65, 158);
  --blue-red-200: rgb(7, 79, 189);
  --blue-red-250: rgb(13, 93, 220);
  --blue-red-300: rgb(20, 108, 253);
  --blue-red-350: rgb(76, 142, 255);
  --blue-red-400: rgb(121, 172, 255);
  --blue-red-450: rgb(165, 200, 255);
  --blue-red-500: rgb(210, 228, 255);
  --blue-red-550: rgb(254, 215, 214);
  --blue-red-600: rgb(249, 175, 174);
  --blue-red-650: rgb(241, 134, 135);
  --blue-red-700: rgb(229, 89, 97);
  --blue-red-750: rgb(215, 21, 58);
  --blue-red-800: rgb(191, 15, 52);
  --blue-red-850: rgb(167, 10, 45);
  --blue-red-900: rgb(143, 5, 39);
  --blue-red-950: rgb(121, 2, 32);
  --blue-red-1000: rgb(99, 0, 25);
  --blue-orange-50: rgb(0, 38, 100);
  --blue-orange-100: rgb(1, 51, 128);
  --blue-orange-150: rgb(3, 65, 158);
  --blue-orange-200: rgb(7, 79, 189);
  --blue-orange-250: rgb(13, 93, 220);
  --blue-orange-300: rgb(20, 108, 253);
  --blue-orange-350: rgb(76, 142, 255);
  --blue-orange-400: rgb(121, 172, 255);
  --blue-orange-450: rgb(165, 200, 255);
  --blue-orange-500: rgb(210, 228, 255);
  --blue-orange-550: rgb(255, 226, 214);
  --blue-orange-600: rgb(255, 196, 173);
  --blue-orange-650: rgb(254, 166, 131);
  --blue-orange-700: rgb(250, 134, 87);
  --blue-orange-750: rgb(243, 99, 27);
  --blue-orange-800: rgb(224, 85, 22);
  --blue-orange-850: rgb(204, 70, 17);
  --blue-orange-900: rgb(185, 56, 11);
  --blue-orange-950: rgb(167, 42, 5);
  --blue-orange-1000: rgb(148, 27, 0);
  --purple-yellow-50: rgb(68, 17, 112);
  --purple-yellow-100: rgb(81, 30, 136);
  --purple-yellow-150: rgb(93, 43, 161);
  --purple-yellow-200: rgb(106, 57, 187);
  --purple-yellow-250: rgb(117, 70, 214);
  --purple-yellow-300: rgb(128, 85, 241);
  --purple-yellow-350: rgb(150, 123, 247);
  --purple-yellow-400: rgb(174, 158, 251);
  --purple-yellow-450: rgb(199, 191, 254);
  --purple-yellow-500: rgb(227, 223, 255);
  --purple-yellow-550: rgb(255, 240, 218);
  --purple-yellow-600: rgb(255, 224, 180);
  --purple-yellow-650: rgb(254, 208, 139);
  --purple-yellow-700: rgb(252, 192, 93);
  --purple-yellow-750: rgb(250, 175, 5);
  --purple-yellow-800: rgb(219, 153, 3);
  --purple-yellow-850: rgb(189, 132, 2);
  --purple-yellow-900: rgb(160, 111, 1);
  --purple-yellow-950: rgb(132, 91, 0);
  --purple-yellow-1000: rgb(105, 72, 0);
  --fuchsia-teal-50: rgb(101, 0, 77);
  --fuchsia-teal-100: rgb(123, 2, 95);
  --fuchsia-teal-150: rgb(146, 4, 114);
  --fuchsia-teal-200: rgb(169, 8, 133);
  --fuchsia-teal-250: rgb(193, 13, 153);
  --fuchsia-teal-300: rgb(217, 18, 174);
  --fuchsia-teal-350: rgb(230, 91, 191);
  --fuchsia-teal-400: rgb(240, 136, 207);
  --fuchsia-teal-450: rgb(248, 177, 223);
  --fuchsia-teal-500: rgb(253, 216, 239);
  --fuchsia-teal-550: rgb(214, 229, 232);
  --fuchsia-teal-600: rgb(174, 203, 209);
  --fuchsia-teal-650: rgb(134, 178, 186);
  --fuchsia-teal-700: rgb(93, 153, 164);
  --fuchsia-teal-750: rgb(46, 128, 142);
  --fuchsia-teal-800: rgb(39, 114, 127);
  --fuchsia-teal-850: rgb(32, 101, 113);
  --fuchsia-teal-900: rgb(25, 88, 98);
  --fuchsia-teal-950: rgb(18, 75, 84);
  --fuchsia-teal-1000: rgb(11, 63, 71);
}
